<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3CB043" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-card tile flat>
          <v-layout wrap justify-center px-8 py-5>
            <v-flex xs11 text-left v-if="check">
              <span
                style="
                  font-family: poppinssemibold;
                  font-size: 18px;
                  color: #393939;
                "
              >
                Delivery Information
              </span>
            </v-flex>
            <v-flex xs12 text-left v-else>
              <span
                style="
                  font-family: poppinssemibold;
                  font-size: 18px;
                  color: #393939;
                "
              >
                Delivery Information
              </span>
            </v-flex>
            <v-flex xs1 v-if="check">
              <v-icon @click="closeDialog" color="#000000">mdi-close</v-icon>
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            justify-center
            pt-8
            px-5
            style="font-size: 14px; color: #1f1f1f; font-family: RobotoRegular"
          >
          <v-flex xs12 sm6 text-left px-2>
            <span>First Name </span>
            <v-text-field
              ref="firstname"
              background-color="#F5F5F5"
              solo
              placeholder="First Name"
              flat
              dense
              :rules="[rules.required]"
              v-model="fstname"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 text-left px-2>
            <span>Last Name </span>
            <v-text-field
              ref="firstname"
              background-color="#F5F5F5"
              solo
              placeholder="Last Name"
              flat
              dense
              :rules="[rules.required]"
              v-model="lstname"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 text-left px-2>
            <span> Email </span>
            <v-text-field
              ref="email"
              placeholder="Email"
              background-color="#F5F5F5"
              solo
              flat
              dense
              :rules="[rules.required]"
              v-model="email"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 text-left px-2>
            <span>Address </span>
            <v-text-field
              ref="streetAddress"
              placeholder="Address"
              background-color="#F5F5F5"
              solo
              flat
              dense
              :rules="[rules.required]"
              v-model="address"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 text-left px-2>
            <span>Pincode</span>
            <v-text-field
            ref="pincode"
            placeholder="Pincode"
            background-color="#F5F5F5"
            solo
            flat
            type="number"
            dense
            :rules="[rules.required]"
            v-model="pincode"
            @change="getPinCode"
          ></v-text-field>

          </v-flex>
          
          <v-flex xs12 sm6 text-left px-2>
            <span>District</span>
            <v-text-field
                  ref="district"
                  placeholder="District"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="district"
            
                ></v-text-field>
          </v-flex>
          
          <v-flex xs12 sm6 text-left px-2>
            <span>State</span>
            <v-text-field
              ref="state"
              placeholder="State"
              background-color="#F5F5F5"
              solo
              flat
              dense
              :rules="[rules.required]"
              v-model="state"
         
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 text-left px-2>
            <span> Country </span>
            <v-text-field
              ref="country"
              placeholder="Country"
              background-color="#F5F5F5"
              solo
              flat
              dense
              :rules="[rules.required]"
              v-model="country"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 text-left px-2>
            <span> Landmark </span>
            <v-text-field
              ref="landmark"
              placeholder="Landmark"
              background-color="#F5F5F5"
              solo
              flat
             
              dense
              :rules="[rules.required]"
              v-model="landmark"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 text-left px-2>
            <span> Phone </span>
            <v-text-field
              ref="phone"
              placeholder="Phone"
              background-color="#F5F5F5"
              solo
              flat
              dense
              type="number"
              :rules="[rules.required]"
              v-model="mobileNum"
            ></v-text-field>
          </v-flex>
           
          </v-layout>
          <v-layout wrap justify-center py-5 px-6 v-if="check">
          
            <v-flex xs6 text-center>
              <v-layout wrap>
                <v-flex xs12>
                  <v-btn
                  :ripple="false"
                  elevation="0"
                  rounded
                  color="#444645"
                  dark
                  @click="validateInput"
                >
                  <span
                    style="
                      font-family: poppinssemibold;
                      font-size: 12px;
                      color: #fff;
                      text-transform: none;
                    "
                  >
                    Add Address
                  </span>
                </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-end py-5 px-6 v-else>
            <!-- <v-flex xs6 px-2>
                <v-btn
                  :ripple="false"
                  depressed
                  block
                  tile
                  color="#F9F9F9"
                  @click="closeDialog"
                >
                  <span
                    style="
                      font-family: poppinssemibold;
                      font-size: 12px;
                      color: #000;
                      text-transform: none;
                    "
                  >
                    Cancel
                  </span>
                </v-btn>
              </v-flex> -->
            <v-flex xs6 text-left>
              <v-layout wrap>
                <v-flex xs1>
                  <v-checkbox v-model="checked" color="#056848" dense>
                  </v-checkbox>
                </v-flex>
                <v-flex xs11>
                  <span
                    style="
                      color: #1f1f1f;
                      font-family: poppinsregular;
                      font-size: 14px;
                    "
                    >Save my information for a faster checkout</span
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 px-2 text-right>
              <v-btn
              :ripple="false"
              depressed
              
              
              color="#444645"
             @click="validateInput"
            >
              <span
                style="
                  font-family: poppinssemibold;
                  font-size: 12px;
                  color: #fff;
                  text-transform: none;
                "
              >
                Add Address
              </span>
            </v-btn>
              <!-- <span
                  style="
                    font-family: opensansregular;
                    font-size: 12px;
                    color: #1874ff;
                    text-transform: none;
                    text-decoration: underline;
                    cursor: pointer;
                  "
                  @click="validateInput"
                >
                  Use a saved Address
                </span> -->
              <!-- <v-btn :ripple="false" block text >
                
              </v-btn> -->
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
  <script>
import axios from "axios";
export default {
  props:["check"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      formHasErrors: false,
      timeout: 5000,
      checked: true,
      msg: null,
      fstname: null,
      lstname:null,
      address: null,
      locality: null,
      //city: null,
      district: null,
      state: null,
      country: null,
      pincode: null,
      landmark:null,
      mobileNum: null,
      email: null,
      states: [],
      pincodeArray:[],

      rules: {
        required: (value) => !!value || "Required.",
        min: (value) => value.length >= 8 || "Min 8 characters",
      },
    };
  },
  computed: {
    form() {
      return {
        firstname: this.fstname,
        lastname:this.lstname,
        address: this.address,
        district: this.district,
        state: this.state,
        country: this.country,
        pincode: this.pincode,
        landmark: this.landmark,
        mobileNo: this.mobileNum,
        email: this.email,
      };
    },
      userData()
      {
        return this.$store.state.userData
      },
      appUserId() {
      return this.$store.state.id
    },
    UserId() {
      return this.$store.state.userId;
    },
  },
  beforeMount() {
      // if(this.userData)
      // this.name = this.userData.firstname;
      // this.lastname = this.userData.lastname;
      // this.pincode =this.userData.pincode;
      // this.phone =this.userData.phone;
      // this.email =this.userData.email;
     this.getState()
  },
  watch:{
    pincode(newPincode) {
    if (!newPincode) {
      this.district = ''; // Clear district if pincode is empty
      this.state = '';    // Clear state if pincode is empty
    } else {
      this.getPinCode();
    }
  }
},

//   watch:{
//     pincode(newPincode) {
//     if (!newPincode) {
//       this.district = ''; // Clear district if pincode is empty
//       this.state = '';    // Clear state if pincode is empty
//     } else {
//       this.getPinCode();
//     }
//   },
// },
  methods: {
    closeDialog() {
      this.$emit("stepper", {
        ref: "AddAddress",
        addressAddDialog: false,
      });
    },
    validateInput() {
      this.formHasErrors = false;
      var phoneformat = /^\d{10}$/;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) {
          this.formHasErrors = true;
          this.msg = "Please Provide " + f;
          this.showSnackBar = true;
          return;
        }
        // if (!this.$refs[f].validate(true)) {
        //   this.msg = "Please Provide Valid " + f;
        //   this.showSnackBar = true;
        //   this.formHasErrors = true;
        //   return;
        // }
      });
      if (!this.mobileNum.match(phoneformat)) {
        this.msg = "Please Provide valid Phone Number";
        this.showSnackBar = true;
        return;
      }
      if (this.formHasErrors == false) this.addAddress();
    },

    addAddress() {
      this.appLoading = true;
      var address = {};
      address["fstname"] = this.fstname;
      address["lstname"] = this.lstname;
      address["address"] = this.address;
      //address["city"] = this.city;
      address["district"] = this.district;
      address["state"] = this.state;
      address["country"] = this.country;
      address["pincode"] = this.pincode;
      address["mobileNum"] = this.mobileNum;
      address["landmark"] = this.landmark;
      address["email"] = this.email;
      address["id"] = localStorage.getItem("id");
      address["guestId"] = localStorage.getItem("userId");
      axios({
        method: "POST",
        url: "/user/address/addEdit",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: address,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.fstname = null;
            this.lstname = null;
            this.address = null;
            //this.city = null;
            this.district = null;
            this.state = null;
            this.country = null;
            this.pincode = null;
            this.mobileNum = null;
            this.email = null;
            this.landmark=null;
            this.addressAddDialog = false;
            //this.getAddress();
            this.$emit("stepper", {
              ref: "Add",
              getAddress: true,
            });
          } else {
            this.msg = "Something went wrong";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getState() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/states/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            if (response.data.data) {
              this.states = response.data.data;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getPinCode() {
  if (!this.pincode) {
    this.district = '';
    this.state = '';
    return; // Exit early if pincode is empty
  }

  this.appLoading = true;
  axios({
    url: "/user/address/pincode",
    method: "POST",
    headers: {
      token: localStorage.getItem("token"),
    },
    data: {
      pincode: this.pincode,
    },
  })
    .then((response) => {
      this.appLoading = false;
      const pinData = response.data.data;
      if (pinData) {
        this.district = pinData.district; // Autofill district
        this.state = pinData.stateName;   // Autofill state
      }
    })
    .catch((err) => {
      this.appLoading = false;
      this.ServerError = true;
      console.error(err);
    });
},
  },
};
</script>